import React from 'react';
import { Switch, Route, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import FormGeocerca from './formGeocerca';
import tablaGeocerca from './tablaGeocerca';
import DetallesGeocerca from './detallesGeocerca';

const Geocercas = ({ match: { url } }) => (
  <div className="container">
    <div className="row">
      <div className="col">

        <h2>Administración de Geocercas</h2>

        <ul className="sl-pills nav nav-pills">
          <li className="nav-item">
            <NavLink exact to="/panel/geocercas" className="btn btn-sm">
              Lista de geocercas
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink exact to="/panel/geocercas/geocerca" className="btn btn-sm">
              <FontAwesomeIcon icon={faPlus} />
              Nueva geocerca
            </NavLink>
          </li>
        </ul>

        <div className="card mirai-shadow border-top-square">
          <div className="card-body">
            <Switch>
              <Route exact path={`${url}`} component={tablaGeocerca} />
              <Route exact path={`${url}/geocerca`} component={FormGeocerca} />
              <Route exact path={`${url}/geocerca/:id`} component={FormGeocerca} />
              <Route exact path={`${url}/geocerca/detalles/:id`} component={DetallesGeocerca} />
            </Switch>
          </div>
        </div>

      </div>
    </div>
  </div>
);

export default Geocercas;
